export default "/images/avatar-6.jpg?dc44eabff29dbd9780cb758cf0716cd3";